import React, { useState } from 'react';
import { useSpring } from '@react-spring/web';

import { Wrapper, Button, Icon } from './ControlButton.styled';

interface Props {
    id: string;
    handleOnClick: () => void;
    ariaLabel?: string;
    previous?: boolean;
    next?: boolean;
    className?: string;
    tabIndex?: number;
}

const ControlButton: React.FC<Props> = props => {
    const { id, ariaLabel, previous, next, handleOnClick, className, tabIndex } = props;
    const [isPressed, setIsPressed] = useState(false);
    const buttonSpring = useSpring({
        transform: isPressed ? 'scale(0.85)' : 'scale(1)',
        config: {
            tension: 200,
            friction: 10
        }
    });

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            setIsPressed(true);
        }
    };

    const handleKeyUp = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            setIsPressed(false);
        }
    };

    const type = previous ? 'previous' : next ? 'next' : 'next';

    return (
        <Wrapper>
            <Button
                id={id}
                aria-label={ariaLabel ? ariaLabel : `Go to ${type} item`}
                style={buttonSpring}
                onClick={() => handleOnClick()}
                onMouseDown={() => setIsPressed(true)}
                onMouseUp={() => setIsPressed(false)}
                onMouseLeave={() => setIsPressed(false)}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
                className={className}
                tabIndex={tabIndex}
                data-is-pressed={isPressed}
            >
                <Icon $type={type} />
            </Button>
        </Wrapper>
    );
};

export default ControlButton;
